module.exports = __webpack_public_path__ + "static/media/google-drive.5c720276.svg";